import { createContext, useContext, useReducer } from 'react'
import { initialState, reducer } from './reducer'
import { useComponentIsMountedRef } from 'Hooks'

DetailDataContext = createContext()

export DetailDataProvider = ({ children }) ->
  isMounted = useComponentIsMountedRef()
  [state, dispatch] = useReducer(reducer, initialState)

  protectedDispatch = (args...) ->
    return unless isMounted.current
    dispatch(args...)

  <DetailDataContext.Provider value={[state, protectedDispatch]}>
    { children }
  </DetailDataContext.Provider>

export useDetailData = () ->
  useContext(DetailDataContext)
